<template>
    <div>
        <div style="background: #222222">
            <img src="../../assets/unifun/solution/10.png" style="width: 100%;height: auto;display: block" alt="">
        </div>
        <div style="background: #222222;" class="center solution-info-padding-70">
            <div class="solution-info-title">
                <h2 class="white  font-28">
                    <img src="../../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">系统简介</span> <img src="../../assets/img/2.png" width="31" alt="">

                </h2>
                <div class="margin-top-20 line-height-30 white">
                    华方智能电力巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对变电站场景的全方位自主巡检和实时监控。
                </div>

            </div>
        </div>
        <div class="padding-20 margin-top-20 background-white ">
            <div class="index-div-content">
                <div class="margin-bottom-20 center font-28" style="color: #1B1B1B">
                    <img src="../../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">系统架构</span> <img src="../../assets/img/2.png" width="31" alt="">

                </div>
                <div >
                    <img src="../../assets/unifun/solution/9.png" class="solution-spring"   alt="">
                </div>
            </div>

        </div>
        <div class="padding-20 margin-top-20 background-white ">
            <div class="index-div-content" >
                <div class="margin-bottom-20 center font-28" style="color: #1B1B1B">  <img src="../../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">系统功能</span> <img src="../../assets/img/2.png" alt="" width="31"></div>
                <br><br>
                <div >
                    <img src="../../assets/unifun/solution/8.png" class="solution-function-img" alt="">
                </div>
            </div>

        </div>
        <example :info="info"/>
    </div>
</template>

<script>
    import example from "../commom/example";
    export default {
        name: "electricity",
        components:{example},
        data(){
            return{
                info:[
                    {
                        title:'内蒙某变电所项目',
                        content:'项目位于内蒙古鄂尔多斯准格尔旗薛家湾某村境内，是依托紧邻的年产1200万吨的内蒙古某煤矿的项目，变电所隧道长约数公里，采用挂轨智能巡检机器人进行巡检，巡检设备包括变电站机柜温度、机柜仪表读数、水泵红外温度和水泵仪表读数、电机红外温度和仪表读数、风扇红外温度等。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/07-%E7%85%A4%E5%AE%89Cicada-%E5%8F%98%E7%94%B5%E6%89%80%E5%B7%A1%E6%A3%80-%E7%85%A4%E7%A7%91%E9%99%A2-%E9%85%B8%E5%88%BA%E6%B2%9F.mp4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/30.png'
                    },
                ]
            }
        },

    }
</script>

<style scoped>

</style>